import { Tour } from "./Tour";

export class TourDefinitions {
    public definitions: Tour[];
}
